import { REQUEST, SUCCESS, FAILURE } from '../../actions/auth/logout';

const initialState = {
  isLoading: false,
  error: null
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null
      };
    case SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null
      };
    case FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    default:
      return state;
  }
};
